module.exports = __webpack_public_path__ + "static/media/login.5fa24c15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/login.jpg
// module id = 1207
// module chunks = 0